import React, { Suspense, lazy } from "react";
import ScrollToTop from "./ScrollToTop";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import Layout from "./Layout";
import Home from "../pages/home/Home";
import RouteLoading from "../components/RouteLoading";
import RouteErrorBoundary from "../components/RouteErrorBoundary";
import { getRootSlugRoute, ROOT_SLUG_ROUTE } from "../helper/rootSlugRoute";

const serverRequire = (modulePath) =>
  module.constructor.createRequire(__filename)(modulePath);

const lazyOnClient = (importer, serverLoader) => {
  if (typeof window === "undefined") {
    return function ServerRouteComponent(props) {
      const module = serverLoader();
      const Component = module.default || module;
      return <Component {...props} />;
    };
  }

  return lazy(importer);
};


// import HomeUs from "../usWebsite/homepage/HomeUs";
// import UsLayout from "./UsLayout";
// import BlogListUs from "../usWebsite/bloglisting/BlogListUs";
// import Network from "../usWebsite/Network/Network";

const Governance = lazyOnClient(() => import("../pages/governance/Governance"), () => serverRequire("../pages/governance/Governance"));
const EthicsCompliances = lazyOnClient(() => import("../pages/ethicsCompliances/EthicsCompliances"), () => serverRequire("../pages/ethicsCompliances/EthicsCompliances"));
const CSR = lazyOnClient(() => import("../pages/industries/csr/CSR"), () => serverRequire("../pages/industries/csr/CSR"));
const Location = lazyOnClient(
  () => import("../pages/location/Location"),
  () => serverRequire("../pages/location/Location")
);
const CareerForm = lazyOnClient(() => import("../pages/careerForm/CareerForm"), () => serverRequire("../pages/careerForm/CareerForm"));
const Career = lazyOnClient(
  () => import("../pages/career/Career"),
  () => serverRequire("../pages/career/Career")
);
const CareerListing = lazyOnClient(
  () => import("../pages/careerListing/CareerListing"),
  () => serverRequire("../pages/careerListing/CareerListing")
);
const CareerDetail = lazyOnClient(
  () => import("../pages/careerDetail/CareerDetail"),
  () => serverRequire("../pages/careerDetail/CareerDetail")
);
const OperationExcellence = lazyOnClient(() => import("../pages/operationExcellence/OperationExcellence"), () => serverRequire("../pages/operationExcellence/OperationExcellence"));
const Warehouse = lazyOnClient(() => import("../pages/services/warehouse/Warehouse"), () => serverRequire("../pages/services/warehouse/Warehouse"));
const CsrPolicy = lazyOnClient(() => import("../pages/csrpolicy/CsrPolicy"), () => serverRequire("../pages/csrpolicy/CsrPolicy"));
const CookiesPolicy = lazyOnClient(() => import("../pages/cookiesPolicy/CookiesPolicy"), () => serverRequire("../pages/cookiesPolicy/CookiesPolicy"));
const PressRelease = lazyOnClient(
  () => import("../pages/pressRelease/PressRelease"),
  () => serverRequire("../pages/pressRelease/PressRelease")
);
const Experience = lazyOnClient(() => import("../pages/technologies/experience/Experience"), () => serverRequire("../pages/technologies/experience/Experience"));
const SoftwareDevelopment = lazyOnClient(() => import("../pages/technologies/softwareDevelopment/SoftwareDevelopment"), () => serverRequire("../pages/technologies/softwareDevelopment/SoftwareDevelopment"));
const InfrastructureCybersecurity = lazyOnClient(() => import("../pages/technologies/infrastructureCbersecurity/InfrastructureCybersecurity"), () => serverRequire("../pages/technologies/infrastructureCbersecurity/InfrastructureCybersecurity"));
const DataAnalytics = lazyOnClient(() => import("../pages/technologies/dataAnalytics/DataAnalytics"), () => serverRequire("../pages/technologies/dataAnalytics/DataAnalytics"));
const Iot = lazyOnClient(() => import("../pages/technologies/iot/iot"), () => serverRequire("../pages/technologies/iot/iot"));
const MoveInReady = lazyOnClient(() => import("../pages/facilities/moveReady/MoveInReady"), () => serverRequire("../pages/facilities/moveReady/MoveInReady"));
const ColdChains = lazyOnClient(() => import("../pages/facilities/coldChains/ColdChains"), () => serverRequire("../pages/facilities/coldChains/ColdChains"));
const LocationServed = lazyOnClient(() => import("../pages/facilities/locationServed/LocationServed"), () => serverRequire("../pages/facilities/locationServed/LocationServed"));
const ColdStorageRefrigeration = lazyOnClient(() => import("../pages/facilities/coldStorage/ColdStorageRefrigeration"), () => serverRequire("../pages/facilities/coldStorage/ColdStorageRefrigeration"));
const TechBasedServices = lazyOnClient(() => import("../pages/facilities/techBased/TechBasedServices"), () => serverRequire("../pages/facilities/techBased/TechBasedServices"));
const CertificationLicences = lazyOnClient(() => import("../pages/facilities/certificationLicences/CertificationLicences"), () => serverRequire("../pages/facilities/certificationLicences/CertificationLicences"));
const Pallets = lazyOnClient(() => import("../pages/facilities/pallets/Pallets"), () => serverRequire("../pages/facilities/pallets/Pallets"));
const Blog = lazyOnClient(
  () => import("../pages/blog/Blog"),
  () => serverRequire("../pages/blog/Blog")
);
const BlogDetail = lazyOnClient(
  () => import("../pages/blogDetail/BlogDetail"),
  () => serverRequire("../pages/blogDetail/BlogDetail")
);
const Contact = lazyOnClient(() => import("../pages/contact/Contact"), () => serverRequire("../pages/contact/Contact"));
const ErrorPage = lazyOnClient(() => import("../pages/errorPage/errorPage"), () => serverRequire("../pages/errorPage/errorPage"));
const ThankYou = lazyOnClient(() => import("../pages/thankYou/ThankYou"), () => serverRequire("../pages/thankYou/ThankYou"));
const About = lazyOnClient(() => import("../pages/about/About"), () => serverRequire("../pages/about/About"));
const Starting = lazyOnClient(() => import("../pages/services/starting/Starting"), () => serverRequire("../pages/services/starting/Starting"));
const Growing = lazyOnClient(() => import("../pages/services/growing/Growing"), () => serverRequire("../pages/services/growing/Growing"));
const CircularEconomy = lazyOnClient(() => import("../pages/services/circular-economy/CircularEconomy"), () => serverRequire("../pages/services/circular-economy/CircularEconomy"));
const Scaling = lazyOnClient(() => import("../pages/services/scaling/Scaling"), () => serverRequire("../pages/services/scaling/Scaling"));
const FulFillment = lazyOnClient(() => import("../pages/services/fulfillment/FulFillment"), () => serverRequire("../pages/services/fulfillment/FulFillment"));
const OmniChannel = lazyOnClient(() => import("../pages/services/omnichannel/OmniChannel"), () => serverRequire("../pages/services/omnichannel/OmniChannel"));
const LandFreight = lazyOnClient(() => import("../pages/transport/land_freight/LandFreight"), () => serverRequire("../pages/transport/land_freight/LandFreight"));
const AirFreight = lazyOnClient(() => import("../pages/transport/air_freight/AirFreight"), () => serverRequire("../pages/transport/air_freight/AirFreight"));
const OceanFreight = lazyOnClient(() => import("../pages/transport/occean_freight/OceanFreight"), () => serverRequire("../pages/transport/occean_freight/OceanFreight"));
const IntermodalLogistics = lazyOnClient(() => import("../pages/transport/intermodal_logistics/IntermodalLogistics"), () => serverRequire("../pages/transport/intermodal_logistics/IntermodalLogistics"));
const TermsCondition = lazyOnClient(() => import("../pages/termsCondition/TermsCondition"), () => serverRequire("../pages/termsCondition/TermsCondition"));
const PrivacyPolicy = lazyOnClient(() => import("../pages/privacyPolicy/PrivacyPolicy"), () => serverRequire("../pages/privacyPolicy/PrivacyPolicy"));
const Faq = lazyOnClient(
  () => import("../pages/faq/Faq"),
  () => serverRequire("../pages/faq/Faq")
);
const ProjectLogistics = lazyOnClient(() => import("../pages/transport/project_logistics/ProjectLogistics"), () => serverRequire("../pages/transport/project_logistics/ProjectLogistics"));
const Fashion = lazyOnClient(() => import("../pages/industries/fashion/Fashion"), () => serverRequire("../pages/industries/fashion/Fashion"));
const FMCG = lazyOnClient(() => import("../pages/industries/fmcg/FMCG"), () => serverRequire("../pages/industries/fmcg/FMCG"));
const Chemicals = lazyOnClient(() => import("../pages/industries/chemicals/Chemicals"), () => serverRequire("../pages/industries/chemicals/Chemicals"));
const Technology = lazyOnClient(() => import("../pages/industries/technology/Technology"), () => serverRequire("../pages/industries/technology/Technology"));
const Automotives = lazyOnClient(() => import("../pages/industries/automotives/Automotives"), () => serverRequire("../pages/industries/automotives/Automotives"));
const Sport = lazyOnClient(() => import("../pages/industries/sports/Sport"), () => serverRequire("../pages/industries/sports/Sport"));
const Retail = lazyOnClient(() => import("../pages/industries/retails/Retail"), () => serverRequire("../pages/industries/retails/Retail"));
const PremiumGoods = lazyOnClient(() => import("../pages/industries/premium_goods/PremiumGoods"), () => serverRequire("../pages/industries/premium_goods/PremiumGoods"));
const PharmaHealthcare = lazyOnClient(() => import("../pages/industries/pharma-healthcare/PharmaHealthcare"), () => serverRequire("../pages/industries/pharma-healthcare/PharmaHealthcare"));
const Entertainment = lazyOnClient(() => import("../pages/industries/entertainment/Entertainment"), () => serverRequire("../pages/industries/entertainment/Entertainment"));
const WideGoods = lazyOnClient(() => import("../pages/industries/wide-goods/WideGoods"), () => serverRequire("../pages/industries/wide-goods/WideGoods"));
const Perishables = lazyOnClient(() => import("../pages/industries/perishables/Perishables"), () => serverRequire("../pages/industries/perishables/Perishables"));
const ElectronicProofDelivery = lazyOnClient(() => import("../pages/valueAdded/ElectronicProof/ElectronicProofDelivery"), () => serverRequire("../pages/valueAdded/ElectronicProof/ElectronicProofDelivery"));
const Barcoding = lazyOnClient(() => import("../pages/valueAdded/barcoding/Barcoding"), () => serverRequire("../pages/valueAdded/barcoding/Barcoding"));
const PackagingServices = lazyOnClient(() => import("../pages/valueAdded/packagingServices/PackagingServices"), () => serverRequire("../pages/valueAdded/packagingServices/PackagingServices"));
const CrossDockingVas = lazyOnClient(() => import("../pages/valueAdded/crossDocking/CrossDockingVas"), () => serverRequire("../pages/valueAdded/crossDocking/CrossDockingVas"));
const ProjectMovements = lazyOnClient(() => import("../pages/valueAdded/projectMovements/ProjectMovements"), () => serverRequire("../pages/valueAdded/projectMovements/ProjectMovements"));
const LogisticsConsultancy = lazyOnClient(() => import("../pages/valueAdded/logisticsConsultancy/LogisticsConsultancy"), () => serverRequire("../pages/valueAdded/logisticsConsultancy/LogisticsConsultancy"));
const PressDetails = lazyOnClient(
  () => import("../pages/pressDetails/PressDetails"),
  () => serverRequire("../pages/pressDetails/PressDetails")
);
const DataIntegration = lazyOnClient(() => import("../pages/technologies/dataIntegration/DataIntegration"), () => serverRequire("../pages/technologies/dataIntegration/DataIntegration"));
const Electronic = lazyOnClient(() => import("../pages/industries/electronic/Electronic"), () => serverRequire("../pages/industries/electronic/Electronic"));
const Energy = lazyOnClient(() => import("../pages/industries/energy/Energy"), () => serverRequire("../pages/industries/energy/Energy"));
const Cosmetics = lazyOnClient(() => import("../pages/industries/cosmetics/Cosmetics"), () => serverRequire("../pages/industries/cosmetics/Cosmetics"));
const GovermentSector = lazyOnClient(() => import("../pages/industries/ggovermentSector/GovermentSector"), () => serverRequire("../pages/industries/ggovermentSector/GovermentSector"));
const TransportationDistribution = lazyOnClient(() => import("../pages/solutions/transportationDistribution/TransportationDistribution"), () => serverRequire("../pages/solutions/transportationDistribution/TransportationDistribution"));
const ExpressCargo = lazyOnClient(() => import("../pages/solutions/expressCargo/ExpressCargo"), () => serverRequire("../pages/solutions/expressCargo/ExpressCargo"));
const FreightForwarding = lazyOnClient(() => import("../pages/solutions/freightForwarding/FreightForwarding"), () => serverRequire("../pages/solutions/freightForwarding/FreightForwarding"));
const CustomClearance = lazyOnClient(() => import("../pages/solutions/customClearance/CustomClearance"), () => serverRequire("../pages/solutions/customClearance/CustomClearance"));
const DigitalLogistics = lazyOnClient(() => import("../pages/solutions/digitalLogistics/DigitalLogistics"), () => serverRequire("../pages/solutions/digitalLogistics/DigitalLogistics"));
const ReverseLogistics = lazyOnClient(() => import("../pages/solutions/reverseLogistics/ReverseLogistics"), () => serverRequire("../pages/solutions/reverseLogistics/ReverseLogistics"));
const OtherIndustries = lazyOnClient(() => import("../pages/otherIndustries/OtherIndustries"), () => serverRequire("../pages/otherIndustries/OtherIndustries"));
const ThirdPartyLogistic = lazyOnClient(() => import("../pages/solutions/thirdpartylogistic/ThirdPartyLogistic"), () => serverRequire("../pages/solutions/thirdpartylogistic/ThirdPartyLogistic"));
const Gallery = lazyOnClient(() => import("../pages/gallery/Gallery"), () => serverRequire("../pages/gallery/Gallery"));
const CertificateCompliances = lazyOnClient(() => import("../pages/certificate/CertificateCompliances"), () => serverRequire("../pages/certificate/CertificateCompliances"));
const Tracking = lazyOnClient(() => import("../pages/tracking/Tracking"), () => serverRequire("../pages/tracking/Tracking"));
const LocationListing = lazyOnClient(() => import("../pages/locationListing/LocationListing"), () => serverRequire("../pages/locationListing/LocationListing"));
const ApparelLogistics = lazyOnClient(() => import("../pages/industries/apparelLogistics/ApparelLogistics"), () => serverRequire("../pages/industries/apparelLogistics/ApparelLogistics"));
const Doxinfinity = lazyOnClient(() => import("../pages/products/doxinfinity/Doxinfinity"), () => serverRequire("../pages/products/doxinfinity/Doxinfinity"));
const Aquarium = lazyOnClient(() => import("../pages/products/aquarium/Aquarium"), () => serverRequire("../pages/products/aquarium/Aquarium"));
const Warehousing = lazyOnClient(() => import("../pages/warehouse/Warehouse"), () => serverRequire("../pages/warehouse/Warehouse"));
const Fins = lazyOnClient(() => import("../pages/products/fins/Fins"), () => serverRequire("../pages/products/fins/Fins"));
const Drizzle = lazyOnClient(() => import("../pages/products/drizzle/Drizzle"), () => serverRequire("../pages/products/drizzle/Drizzle"));
const Wision = lazyOnClient(() => import("../pages/products/wision/Wision"), () => serverRequire("../pages/products/wision/Wision"));
const Vaclogix = lazyOnClient(() => import("../pages/Vaclogix/Vaclogix"), () => serverRequire("../pages/Vaclogix/Vaclogix"));
const AiBlogDetails = lazyOnClient(
  () => import("../pages/aiBlogDetails/AiBlogDetails"),
  () => serverRequire("../pages/aiBlogDetails/AiBlogDetails")
);
const Swim = lazyOnClient(() => import("../pages/products/swim/Swim"), () => serverRequire("../pages/products/swim/Swim"));
const CaseStudy = lazyOnClient(
  () => import("../pages/caseStudy/CaseStudy"),
  () => serverRequire("../pages/caseStudy/CaseStudy")
);
const CaseDetail = lazyOnClient(
  () => import("../pages/caseDetail/CaseDetail"),
  () => serverRequire("../pages/caseDetail/CaseDetail")
);


function BlogRouterHandler({ initialData }) {
  const { slug } = useParams();
  const routeType = getRootSlugRoute(slug);

  if (routeType === ROOT_SLUG_ROUTE.BLOG) {
    return <BlogDetail initialData={initialData} />;
  }

  if (routeType === ROOT_SLUG_ROUTE.PRESS_RELEASE) {
    return <PressDetails initialData={initialData} />;
  }

  return <Location initialData={initialData} />;
}

function Redirect({ to }) {
  if (typeof window !== "undefined") {
    // client-side
    return <Navigate to={to} replace />;
  }
  return null; // SSR just renders nothing
}

export default function NavRouter({ initialData }) {
  return (
    <>
      <ScrollToTop />
      <RouteErrorBoundary>
        <Suspense fallback={<RouteLoading />}>
          <Routes>
          <Route path="/" element={<Layout />}>
          <Route index element={<Home initialData={initialData} />} />
          <Route path="blog-page" element={<Blog initialData={initialData} />} />
          <Route path=":slug" element={<BlogRouterHandler initialData={initialData} />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="ai-blog/:slug" element={<AiBlogDetails initialData={initialData}/>} />
          <Route path="case-study/:caseStudy_slug" element={<CaseDetail initialData={initialData}/>} />
          <Route path="case-study" element={<CaseStudy initialData={initialData}/>} />
          <Route path="about-us" element={<About />} />
          <Route path="shipping-and-receiving-support" element={<Starting />} />
          <Route path="large-enterprises-scalable-logistics-solutions" element={<Growing />} />
          <Route path="cost-effective-logistics-small-medium-businesses" element={<Scaling />} />
          <Route path="circular-economy-logistics-solution" element={<CircularEconomy />} />
          <Route path="omnichannel-ecommerce-logistics-solution" element={<OmniChannel />} />
          <Route path="order-fulfillment-logistics-services" element={<FulFillment />} />
          <Route path="land-freight-forwarding-logistics" element={<LandFreight />} />
          <Route path="air-freight-cargo-services" element={<AirFreight />} />
          <Route path="global-ocean-freight" element={<OceanFreight />} />
          <Route path="smart-warehouses" element={<IntermodalLogistics />} />
          <Route path="global-project-logistics" element={<ProjectLogistics />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="csr-policy" element={<CsrPolicy />} />
          <Route path="terms-and-conditions" element={<TermsCondition />} />
          <Route path="faq" element={<Faq />} />
          <Route path="404" element={<ErrorPage />} />
          <Route path="thank-you" element={<ThankYou />} />
          <Route path="fashion-and-lifestyle-logistics" element={<Fashion />} />
          <Route path="fmcg-logistics" element={<FMCG />} />
          <Route path="chemical-logistics" element={<Chemicals />} />
          <Route path="technology-logistics" element={<Technology />} />
          <Route path="auto-industry-logistics" element={<Automotives />} />
          <Route path="sports-logistics" element={<Sport />} />
          <Route path="retail-lifestyle" element={<Retail />} />
          <Route path="white-goods-logistics" element={<PremiumGoods />} />
          <Route path="industries-healthcare" element={<PharmaHealthcare />} />
          <Route path="entertainment-logistics" element={<Entertainment />} />
          <Route path="wide-cargo-logistics" element={<WideGoods />} />
          <Route path="food-beverages" element={<Perishables />} />
          <Route path="our-team" element={<Governance />} />
          <Route path="about-us-ethics" element={<EthicsCompliances />} />
          <Route path="csr" element={<CSR />} />
          <Route path="cookies-policy" element={<CookiesPolicy />} />
          <Route path="career-form" element={<CareerForm />} />
          <Route path="career" element={<Career initialData={initialData} />} />
          <Route path="career-listing" element={<CareerListing initialData={initialData} />} />
          <Route path="career/:career_slug" element={<CareerDetail initialData={initialData} />} />
          <Route path="operation-exellence" element={<OperationExcellence />} />
          <Route path="supply-chain-management" element={<Warehouse />} />
          {/* solutions */}
          <Route path="transportation-distribution" element={<TransportationDistribution />} />
          <Route path="express-cargo" element={<ExpressCargo />} />
          <Route path="freight-forwarding" element={< FreightForwarding />} />
          <Route path="custom-clearance" element={< CustomClearance />} />
          <Route path="digital-logistics" element={< DigitalLogistics />} />
          <Route path="reverse-logistics" element={<ReverseLogistics />} />
          <Route path="thirdpartylogistic" element={< ThirdPartyLogistic />} />

          {/* industries */}
          <Route path="apparel-logistics" element={<ApparelLogistics />} />
          <Route path="industries-electronics" element={<Electronic />} />
          <Route path="cosmetics" element={<Cosmetics />} />
          <Route path="energy" element={<Energy />} />
          <Route path="govtsector" element={<GovermentSector />} />
          <Route path="other-industries" element={<OtherIndustries />} />

          {/* preesRelease */}
          <Route path="press-release" element={<PressRelease initialData={initialData} />} />

          {/* valueAdded */}
          {/* <Route path="value-added-services" element={<ValueAddedServices />} /> */}
          <Route path="electronic-proof-of-delivery" element={<ElectronicProofDelivery />} />
          <Route path="barcoding-labelling-vas" element={<Barcoding />} />
          <Route path="packaging-services-vas" element={<PackagingServices />} />
          <Route path="cross-docking-vas" element={<CrossDockingVas />} />
          <Route path="project-movements-vas" element={<ProjectMovements />} />
          <Route path="logistics-consultancy-vas" element={<LogisticsConsultancy />} />

          {/* products */}
          <Route path="doxinfinity" element={<Doxinfinity />} />
          <Route path="aquarium" element={<Aquarium />} />
          <Route path="fins" element={<Fins />} />
          <Route path="drizzle" element={<Drizzle/>} />
          <Route path="wision" element={<Wision/>} />
          <Route path="swim" element={<Swim/>} />
          {/* warehouse */}
          <Route path="warehousing" element={<Warehousing />} />

          {/* technologies */}
          <Route path="experience" element={<Experience />} />
          <Route path="software-development" element={<SoftwareDevelopment />} />
          <Route path="infrastructure-cybersecurity" element={<InfrastructureCybersecurity />} />
          <Route path="data-analytics" element={<DataAnalytics />} />
          <Route path="iot" element={<Iot />} />
          <Route path="data-integration" element={<DataIntegration />} />

          {/* facilities */}
          <Route path="move-in-ready-short" element={<MoveInReady />} />
          <Route path="cold-chains" element={<ColdChains />} />
          <Route path="location-served" element={<LocationServed />} />
          <Route path="cold-storage-refrigeration" element={<ColdStorageRefrigeration />} />
          <Route path="tech-based-services" element={<TechBasedServices />} />
          <Route path="certifications-licences" element={<CertificationLicences />} />
          <Route path="pallets" element={<Pallets />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="certification" element={<CertificateCompliances />} />
          <Route path="tracking" element={<Tracking />} />
          <Route path="location" element={<LocationListing />} />
          <Route path="vaclogix" element={<Vaclogix/>} />

          <Route path="*" element={<Redirect to="/404" />} />
          {/* <Route path="*" element={<Navigate to={"/404"} />} /> */}
          </Route>

        {/* US Website Routes */}
        {/* <Route path="/us-en" element={<UsLayout />}>
          <Route index element={<HomeUs />} />
          <Route path="blog-listing" element={<BlogListUs />} />
          <Route path="network" element={<Network/>} />
        </Route>  */}
          </Routes>
        </Suspense>
      </RouteErrorBoundary>
    </>
  )
}
